import Vue from 'vue'
import Router from 'vue-router'
import mid from '@/components/mid'
import help from '@/components/help/help'
import one from '@/components/indexr/one'
import two from '@/components/indexr/two'
import helplast from '@/components/help/helplast'
import index from '@/components/index'
import mindex from '@/components/phone/mindex'
import mmid from '@/components/phone/mmid'
import mhelp from '@/components/phone/mhelp'
import call from  '@/components/phone/call'
import kami from '@/components/product/kami'
import kefu from '@/components/product/kefu'
import pintuan from '@/components/product/pintuan'
import zhuangxiu from '@/components/product/zhuangxiu'
import pkami from '@/components/phone/ppro/pkami'
import pkefu from '@/components/phone/ppro/pkefu'
import ppintuan from '@/components/phone/ppro/ppintuan'
import pzhuangxiu from '@/components/phone/ppro/pzhuangxiu'
import jiejue from '@/components/product/jiejue'
import pjiejue from '@/components/phone/ppro/pjiejue'
import helpcon from '@/components/help/helpcon'
function IsPC(){
  var userAgentInfo = navigator.userAgent;
  var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) { flag = false; break; }
  }
  return flag;
}
var routerFlag = IsPC();
sessionStorage.setItem('flag',routerFlag);
var flagRouter = JSON.parse(sessionStorage.getItem('flag'));
var routers = [];
if (flagRouter){
  routers=[
    {
      path: '/index',
      name: 'index',
      component: index,
      children:[
        {
          path: '/mid',
          name: 'mid',
          component: mid,
          children:[
            {
              path: '/one',
              name: 'one',
              component: one
            },
            {
              path: '/two',
              name: 'two',
              component: two
            },
            {
              path: '/mid',
              //重定向
              redirect: {name: 'one'}
            }
          ]
        },
        {
          path: '/help',
          name: 'help',
          component: help,
          children: [
            {
              path:'/helplast',
              name: 'helplast',
              component: helplast
            },
            {
              path:'/helpcon',
              name: 'helpcon',
              component: helpcon
            },
            {
              path: '/help',
              //重定向
              redirect: {name: 'helplast'}
            }

          ]
        },
        {
          path:'/kami',
          name:'kami',
          component:kami
        },
        {
          path:'/kefu',
          name:'kefu',
          component:kefu
        },
        {
          path:'/pintuan',
          name:'pintuan',
          component:pintuan
        },
        {
          path:'/zhuangxiu',
          name:'zhuangxiu',
          component:zhuangxiu
        },
        {
          path:'/jiejue',
          name:'jiejue',
          component:jiejue
        },
        {
          path: '/index',
          //重定向
          redirect: {name: 'mid'}
        }
      ]},{
      path: '*',
      //重定向
      redirect: {name: 'one'}
    }

  ]
}else{
  routers=[
    {
      path: '/mindex',
      name: 'mindex',
      component: mindex,
      children:[
        {
          path: '/mindex/mmid',
          name: 'mmid',
          component: mmid
        },
        {
          path:'mindx/mhelp',
          name:'mhelp',
          component:mhelp
        },
        {
          path:'mindx/pkami',
          name:'pkami',
          component:pkami
        },
        {
          path:'mindx/pkefu',
          name:'pkefu',
          component:pkefu
        },
        {
          path:'mindx/ppintuan',
          name:'ppintuan',
          component:ppintuan
        },
        {
          path:'mindx/pzhuangxiu',
          name:'pzhuangxiu',
          component:pzhuangxiu
        },
        {
          path:'mindx/pjiejue',
          name:'pjiejue',
          component:pjiejue
        },
        {
          path:'mindx/call',
          name:'call',
          component:call
        },
        {
          path:'/mindex',
          redirect: {name: 'mmid'}
        }
      ]
    },
    {
      path: '*',
      //重定向
      redirect: {name: 'mmid'}
    }
  ]
}
Vue.use(Router)
export default new Router({
  routes: routers
})



// WEBPACK FOOTER //
// ./src/router/index.js